<template>
  <div v-if="shouldRenderConfig" :class="getClassName">
    {{ ppName }}
  </div>
</template>
<script>
import { useBundleStore } from "@/stores/modules/bundle";
import { mapState, mapActions } from "pinia";

export default {
  props: ["ppName"]
};
</script>
